import DownloadButton from "../DownloadButton";
import ProfilePlaceholder from "../../assets/svgIcons/ProfilePlaceholder.svg";
import "../../styles/components/transactionPrintLayouts/TrainingAttendanceLayout.css";

const pickValue = (source, keys, fallback = "") => {
  if (!source) return fallback;

  for (const key of keys) {
    const value = source[key];
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      return value;
    }
  }

  return fallback;
};

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const resolveAttendees = (itemDetails = [], headDetails = {}) => {
  const mappedRows = (Array.isArray(itemDetails) ? itemDetails : [])
    .map((item, index) => ({
      sl_no: index + 1,
      employee_name: pickValue(item, [
        "employee_name",
        "name_of_employee",
        "name",
        "trainee_name",
        "employee",
      ]),
      department: pickValue(item, ["department", "dept", "departent"]),
      signature: pickValue(item, [
        "signature",
        "employee_signature",
        "signature_of_employee",
        "signatore",
      ]),
    }))
    .filter(
      (row) =>
        String(row.employee_name || "").trim() !== "" ||
        String(row.department || "").trim() !== "" ||
        String(row.signature || "").trim() !== "",
    );

  if (mappedRows.length > 0) {
    return mappedRows;
  }

  const headRow = {
    sl_no: 1,
    employee_name: pickValue(headDetails, [
      "name_of_employee",
      "employee_name",
      "name",
    ]),
    department: pickValue(headDetails, ["department", "dept", "departent"]),
    signature: pickValue(headDetails, [
      "signature_of_employee",
      "employee_signature",
      "signature",
      "signatore",
    ]),
  };

  const hasHeadRowData =
    String(headRow.employee_name || "").trim() !== "" ||
    String(headRow.department || "").trim() !== "" ||
    String(headRow.signature || "").trim() !== "";

  return hasHeadRowData ? [headRow] : [];
};

export const TrainingAttendanceLayout = ({
  headDetails = {},
  companyData = {},
  itemDetails = [],
}) => {
  let organisationData = {};
  try {
    organisationData = JSON.parse(localStorage.getItem("organisation") || "{}");
  } catch (error) {
    organisationData = {};
  }

  const refNo =
    pickValue(headDetails, ["ref_no", "reference_no", "form_ref_no"]) ||
    "FP/F/TRG/07";
  const revNo = pickValue(headDetails, [
    "rev_no",
    "revision_no",
    "form_rev_no",
  ]);
  const revDate = formatDate(
    pickValue(headDetails, ["rev_date", "revision_date", "form_rev_date"]),
  );

  const trainingTopic = pickValue(headDetails, ["training_topic", "topic"]);
  const trainingDate = formatDate(
    pickValue(headDetails, ["training_date", "date", "created_at"]),
  );
  const duration = pickValue(headDetails, ["duration", "training_duration"]);
  const faculty = pickValue(headDetails, [
    "faculty",
    "trainer_name",
    "trainer",
  ]);
  const trainingType = pickValue(headDetails, [
    "inhouse_external",
    "training_type",
    "type",
  ]);

  const attendeeRows = resolveAttendees(itemDetails, headDetails);

  const attendanceTableData = {
    headings: [
      { display_name: "SL.NO", field_name: "sl_no", is_internal: false },
      {
        display_name: "NAME OF EMPLOYEE",
        field_name: "employee_name",
        is_internal: false,
      },
      {
        display_name: "DEPARTMENT",
        field_name: "department",
        is_internal: false,
      },
      {
        display_name: "SIGNATURE OF EMPLOYEE",
        field_name: "signature",
        is_internal: false,
      },
    ],
    rows: attendeeRows,
  };

  return (
    <div className="training-attendance-page">
      <div className="training-attendance-card">
        <div className="training-attendance-header-row">
          <div className="training-attendance-brand">
            <img
              src={organisationData?.logo_url || ProfilePlaceholder}
              alt="Company Logo"
              className="training-attendance-logo"
            />
            <div className="training-attendance-org-name">
              {organisationData?.name || companyData?.company_name || ""}
            </div>
          </div>
          <div className="training-attendance-title-box">
            TRAINING ATTENDENCE
          </div>
          <div className="training-attendance-ref-box">
            <div>Ref. No. : {refNo || "-"}</div>
            <div>Rev. No. : {revNo || "-"}</div>
            <div>Rev. Date : {revDate || "-"}</div>
          </div>
        </div>

        <div className="training-attendance-main-fields">
          <div className="training-attendance-main-field">
            <span>Training Topic:</span>
            <strong>{trainingTopic}</strong>
          </div>
          <div className="training-attendance-main-field">
            <span>Training date:</span>
            <strong>{trainingDate}</strong>
          </div>
          <div className="training-attendance-main-field">
            <span>DURATION:</span>
            <strong>{duration}</strong>
          </div>
          <div className="training-attendance-main-field">
            <span>Faculty:</span>
            <strong>{faculty}</strong>
          </div>
          <div className="training-attendance-main-field">
            <span>INHOUSE / EXTERNAL</span>
            <strong>{trainingType}</strong>
          </div>
        </div>

        <table className="training-attendance-table">
          <thead>
            <tr>
              <th className="sl-col">Sl. No.</th>
              <th>Name of the Employee</th>
              <th>Department</th>
              <th>Signature of Employee</th>
            </tr>
          </thead>
          <tbody>
            {attendeeRows.length > 0 ? (
              attendeeRows.map((row) => (
                <tr key={`attendee-${row.sl_no}`}>
                  <td className="sl-col">{row.sl_no}</td>
                  <td>{row.employee_name}</td>
                  <td>{row.department}</td>
                  <td>{row.signature}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="sl-col">1</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            )}
          </tbody>
        </table>

        <p className="invoice-system-generated-note">
          This is a system-generated document and does not require a signature.
        </p>

        <div className="invoice-buttons training-attendance-actions">
          <DownloadButton
            tableData={attendanceTableData}
            fileName="training-attendance"
            downloadFormats={["pdf", "full-page-pdf"]}
            fullPageDownload={true}
            fullPageSelector=".training-attendance-page"
          />
        </div>
      </div>
    </div>
  );
};
